import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { ConnectedField } from 'components/ConnectedField'
import { useCurrentOrder } from 'contexts/Order'
import { FormikCurrencyInput } from 'ui/components/Form/Input'

export const PriceField: FC = () => {
  const { order: { currency } = {} } = useCurrentOrder()
  const { t } = useTranslation()

  return (
    <ConnectedField
      name="price"
      id="price"
      label={t('orders.order_details.items.price_field.label')}
      component={FormikCurrencyInput}
      type="text"
      placeholder={t('orders.order_details.items.price_field.placeholder')}
      required
      currency={currency}
    />
  )
}
